import { Component, Input, OnInit } from '@angular/core';
import { IDifference } from "libraries/interfaces/fare-optimisation/IFareOptimisation";


@Component({
    selector: 'display-difference',
    template: `
        <span *ngIf="difference" [class.bold]="difference.impact || isBold" [class]="difference.impact">
            <ng-container
                    *ngIf="difference.actualValue === difference.otherValue || !showOtherValue || !difference.otherValue || showDaysDifference; else displayDifference">
                <ng-container *ngIf="dateFormat; else notDate">{{ actualValueString | date:dateFormat }}
                    {{ daysDifferenceValue }}
                    <span *ngIf="showDaysDifference">
                        {{daysDifference}}
                    </span>
                </ng-container>
                <ng-template #notDate>
                    <ng-container *ngIf="showInnerHtml; else notHtml;">
                     <span [innerHTML]="difference.actualValue"></span>
                    </ng-container>
                    <ng-template #notHtml>{{ difference.actualValue }}</ng-template>
                </ng-template>
            </ng-container>
            <ng-template #displayDifference>
                <ng-container
                        *ngIf="dateFormat && !showInnerHtml; else notDates">{{ otherValueString | date:dateFormat }}
                    > {{ actualValueString | date:dateFormat }}</ng-container>
            </ng-template>
            <ng-template #notDates>
                    <ng-container *ngIf="showInnerHtml; else notHtml;">
                        <span [innerHTML]="difference.actualValue"></span>
                    </ng-container>
                    <ng-template #notHtml>{{ otherValueString }} > {{ actualValueString }}</ng-template>
            </ng-template>
        </span>
    `,
    styles: [`
        .Upgrade {
            color: blue;
        }

        .Downgrade {
            color: red;
        }

        .Change {
            color: orange;
        }

        .bold {
            font-weight: bold;
        }
    `]
})
export class DisplayDifferenceComponent implements OnInit {

    @Input()
    public difference: IDifference;

    @Input()
    public daysDifferenceValue: string;

    @Input()
    public dateFormat: string;

    @Input()
    public showOtherValue: boolean = true;

    @Input()
    public showInnerHtml: boolean = false;

    @Input()
    public showDaysDifference: boolean = false;

    @Input()
    public isBold: boolean = true;

    public daysDifference: string;
    public actualValueString: string;
    public otherValueString: string;

    public ngOnInit(): void {
        if (typeof this.difference?.actualValue === 'string' && typeof this.difference?.otherValue === 'string') {
            this.actualValueString = this.difference.actualValue as string;
            this.otherValueString = this.difference.otherValue as string;
        }

        if (this.showDaysDifference && this.dateFormat) {
            const otherDate: Date = new Date(this.difference.otherValue as string);
            const actualDate: Date = new Date(this.difference.actualValue as string);
            this.daysDifference = otherDate >= actualDate ? "(-" : "(+";
            if (otherDate && actualDate) {
                const diff: number = Math.abs(actualDate.getTime() - otherDate.getTime());
                const diffDays: number = Math.ceil(diff / (1000 * 3600 * 24));
                this.daysDifference = this.daysDifference.concat(diffDays.toString()).concat(")");
            }
        }
    }
}
